module.exports = __webpack_public_path__ + "img/logo-qt-contrast.15f1036e.svg";